import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  async getCategoryById({ commit, state }, { id }) {
    try {
      let category = (state.categories || []).find((p) => p.id === id);
      if (!category) {
        let response = await requestAxios({
          url: `/awy/api/v1/ecommerce/category/${id}`,
          method: "GET",
        });
        category = response.data.data;
      }
      commit(MutationsType.SET_CATEGORY, category);
    } catch (error) {
      console.error("getCategoryById: ", error);
      throw error.response.data;
    }
  },
  async getAllCategories({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/category",
        method: "GET",
      });
      commit(MutationsType.SET_CATEGORIES, response.data.data);
    } catch (error) {
      console.error("getAllCategories: ", error);
      throw error.response.data;
    }
  },
  async saveCategory({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/category",
        method: "POST",
        data: payload,
      });
      commit(MutationsType.ADD_CATEGORY, response.data.data);
    } catch (error) {
      console.error("saveCategory: ", error);
      throw error.response.data;
    }
  },
  async updateCategory({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/category/${id}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_CATEGORY, response.data.data);
    } catch (error) {
      console.error("updateCategory: ", error);
      throw error.response.data;
    }
  },
  async deleteCategory({ commit }, { id }) {
    try {
      await requestAxios({
        url: `/awy/api/v1/ecommerce/category/${id}`,
        method: "DELETE",
      });
      commit(MutationsType.DETELE_CATEGORY, { id });
    } catch (error) {
      console.error("deleteCategory: ", error);
      throw error.response.data;
    }
  },
  resetCategory({ commit }) {
    commit(MutationsType.SET_CATEGORY, null);
  },
  resetModuleCatalogCategory({ commit }) {
    commit(MutationsType.SET_CATEGORY, null);
    commit(MutationsType.SET_CATEGORIES, null);
  },
};
